const ENDPOINTS = {
  INFORMATION: '/information',
};

export default ENDPOINTS;
